(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-grid-to-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(carouselId) {
      var root = document.getElementById(carouselId);
      var track = document.getElementById('track-' + carouselId);
      var dotsContainer = document.getElementById('dots-' + carouselId);
      var arrowsContainer = document.getElementById('arrows-' + carouselId);
      var progressContainer = document.getElementById('progress-' + carouselId);
      var progressThumb = document.getElementById('progress-thumb-' + carouselId);
      if (!track || !dotsContainer) return;

      var enableDesktopCarousel = root && root.dataset.enableDesktopCarousel === 'true';

      var slides = Array.from(track.children);
      if (slides.length === 0) return;

      var current = 0;
      var dots = [];
      var prevBtn = arrowsContainer ? arrowsContainer.querySelector('[data-arrow="prev"]') : null;
      var nextBtn = arrowsContainer ? arrowsContainer.querySelector('[data-arrow="next"]') : null;

      function isMobile() {
        return window.innerWidth < 768;
      }

      function carouselActive() {
        return isMobile() || enableDesktopCarousel;
      }

      function getStep() {
        var slide = slides[0];
        var rect = slide.getBoundingClientRect();
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return rect.width + gap;
      }

      function getWrapperWidth() {
        return track.parentElement.offsetWidth;
      }

      function getMaxTranslate() {
        return Math.max(track.scrollWidth - getWrapperWidth(), 0);
      }

      function buildDots() {
        dotsContainer.innerHTML = '';
        dots = [];
        slides.forEach(function (_, i) {
          var btn = document.createElement('button');
          btn.className = 'dot';
          btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          btn.addEventListener('click', function () {
            goTo(i);
          });
          dotsContainer.appendChild(btn);
          dots.push(btn);
        });
      }

      function updateDots() {
        dots.forEach(function (d, i) {
          d.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }

      function updateProgress(translate) {
        if (!progressThumb) return;
        var wrapperWidth = getWrapperWidth();
        var trackWidth = track.scrollWidth;
        if (trackWidth <= wrapperWidth) {
          progressThumb.style.width = '100%';
          progressThumb.style.left = '0%';
          if (progressContainer) progressContainer.hidden = true;
          return;
        }
        if (progressContainer) progressContainer.hidden = false;
        var widthPct = Math.max(15, (wrapperWidth / trackWidth) * 100);
        var maxTranslate = getMaxTranslate();
        var progressPct = maxTranslate > 0 ? translate / maxTranslate : 0;
        var leftPct = progressPct * (100 - widthPct);
        progressThumb.style.width = widthPct + '%';
        progressThumb.style.left = leftPct + '%';
      }

      function updateArrows(translate) {
        var maxTranslate = getMaxTranslate();
        if (prevBtn) prevBtn.disabled = translate <= 0.5;
        if (nextBtn) nextBtn.disabled = translate >= maxTranslate - 0.5;
      }

      function goTo(index) {
        current = Math.max(0, Math.min(index, slides.length - 1));
        if (!carouselActive()) {
          updateArrows(0);
          return;
        }
        var step = getStep();
        var translate = Math.min(current * step, getMaxTranslate());
        track.style.transform = 'translateX(-' + translate + 'px)';
        updateDots();
        updateProgress(translate);
        updateArrows(translate);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
        });
      }

      var startX = 0;
      track.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
        },
        { passive: true }
      );

      track.addEventListener(
        'touchend',
        function (e) {
          if (!carouselActive()) return;
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) {
            goTo(diff > 0 ? current + 1 : current - 1);
          }
        },
        { passive: true }
      );

      var wasActive = carouselActive();
      window.addEventListener('resize', function () {
        var activeNow = carouselActive();
        if (activeNow !== wasActive) {
          wasActive = activeNow;
          if (!activeNow) {
            track.style.transform = '';
            updateArrows(0);
          } else {
            goTo(current);
          }
        } else if (activeNow) {
          goTo(current);
        }
      });

      buildDots();
      if (carouselActive()) {
        goTo(0);
      } else {
        updateArrows(0);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-carousel-id]').forEach(function (el) {
        initCarousel(el.dataset.carouselId);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-image-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('branch-carousel')) {
    class BranchCarousel extends HTMLElement {
      #viewport = null;
      #slides = [];
      #dotsWrap = null;
      #dots = [];
      #index = 0;
      #timer = null;
      #observer = null;
      #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      connectedCallback() {
        this.#viewport = this.querySelector('[data-carousel-viewport]');
        this.#slides = Array.from(this.querySelectorAll('.branch-carousel-block__slide'));
        this.#dotsWrap = this.querySelector('[data-carousel-dots]');

        if (!this.#viewport || this.#slides.length < 2) return;

        this.#buildDots();
        this.#bindControls();
        this.#observeActiveSlide();
        this.#bindHoverPause();
        this.#startAutoplay();
      }

      disconnectedCallback() {
        this.#stopAutoplay();
        this.#observer?.disconnect();
      }

      #buildDots() {
        this.#slides.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'branch-carousel-block__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          dot.setAttribute('aria-label', `Go to photo ${i + 1}`);
          dot.addEventListener('click', () => this.#goTo(i));
          this.#dotsWrap.append(dot);
          this.#dots.push(dot);
        });
      }

      #bindControls() {
        this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.#goTo(this.#index - 1));
        this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.#goTo(this.#index + 1));

        this.#viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.#goTo(this.#index + 1);
          }
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.#goTo(this.#index - 1);
          }
        });
      }

      #bindHoverPause() {
        this.addEventListener('pointerenter', () => this.#stopAutoplay());
        this.addEventListener('pointerleave', () => this.#startAutoplay());
        this.addEventListener('focusin', () => this.#stopAutoplay());
        this.addEventListener('focusout', () => this.#startAutoplay());
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.#stopAutoplay();
          } else {
            this.#startAutoplay();
          }
        });
      }

      #observeActiveSlide() {
        this.#observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                const i = this.#slides.indexOf(entry.target);
                if (i !== -1) this.#setActive(i);
              }
            }
          },
          { root: this.#viewport, threshold: 0.6 }
        );
        this.#slides.forEach((slide) => this.#observer.observe(slide));
      }

      #setActive(index) {
        this.#index = index;
        this.#dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      }

      #goTo(index) {
        const total = this.#slides.length;
        const nextIndex = (index + total) % total;
        this.#slides[nextIndex].scrollIntoView({
          behavior: this.#reducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      }

      #startAutoplay() {
        if (this.#reducedMotion.matches) return;
        if (this.dataset.autoplay === 'false') return;
        this.#stopAutoplay();
        const delay = Number(this.dataset.autoplayDelay) || 4000;
        this.#timer = window.setInterval(() => this.#goTo(this.#index + 1), delay);
      }

      #stopAutoplay() {
        if (this.#timer) {
          window.clearInterval(this.#timer);
          this.#timer = null;
        }
      }
    }

    customElements.define('branch-carousel', BranchCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
